getActiveEventId